import React from 'react';
import {useTranslation} from 'react-i18next';
import SummaryRow from './SummaryRow';
import s from '../Cart.module.css';

interface OrderSummaryProps {
	orderAmount: number;
	bonusUsed: number | null;
	finalAmount: number;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
	orderAmount,
	bonusUsed,
	finalAmount,
}) => {
	const {t} = useTranslation();

	return (
		<div className={s.buttonWrapper}>
			<SummaryRow
				label={t('Сума замовлення')}
				value={`${orderAmount} грн`}
			/>
			<SummaryRow
				label={t('Використана знижка')}
				value={`${bonusUsed ?? 0} грн`}
			/>
			<SummaryRow
				label={t('Сума на оплату')}
				value={`${finalAmount} грн`}
			/>
		</div>
	);
};

export default OrderSummary;

